module.exports = __webpack_public_path__ + "static/media/6.2ba68f64.jpg";